// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3phAZ","col":"styles_col__1-LAq"};